import { render } from "./Notice.vue?vue&type=template&id=313adb6a&scoped=true"
import script from "./Notice.vue?vue&type=script&lang=js"
export * from "./Notice.vue?vue&type=script&lang=js"

import "./Notice.vue?vue&type=style&index=0&id=313adb6a&scoped=true&lang=css"

import exportComponent from "/var/www/html/dongan_teens2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-313adb6a"]])

export default __exports__